import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { AlertTriangle } from "lucide-react";

import React from "react";

const AlertTooltip = ({ message }: { message: string }) => {
  return (
    <TooltipProvider delayDuration={0}>
      <Tooltip>
        <TooltipTrigger asChild>
          <AlertTriangle
            className="absolute right-2 top-2 text-states-error"
            size={20}
          />
        </TooltipTrigger>
        <TooltipContent>
          <p className="text-sm text-states-error font-semibold">{message}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default AlertTooltip;
